import type { QueryClient } from '@tanstack/react-query';

import { DEAL_QUERY_KEYS } from '@/api/deal/queries';

import { DEMAND_QUERY_KEYS } from './queries';

export const invalidateDemandMutationViews = (queryClient: QueryClient) =>
  Promise.all([
    ...Object.values(DEMAND_QUERY_KEYS).map((key) =>
      queryClient.invalidateQueries({ queryKey: [key] }),
    ),
    queryClient.invalidateQueries({
      queryKey: [DEAL_QUERY_KEYS.marketDepth],
      refetchType: 'all',
    }),
    queryClient.invalidateQueries({ queryKey: [DEAL_QUERY_KEYS.introducerCompanyDemand] }),
  ]);
